import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

const phrases = [
  "Move Better",
  "Live Pain Free",
  "Correct Movement",
  "Lasting Results",
  "Joint-Friendly Strength",
  "Evidence-Based",
];

export const BrandMarquee = () => {
  return (
    <section
      data-testid="brand-marquee"
      className="relative py-12 border-y border-white/5 bg-black overflow-hidden"
    >
      <div className="marquee-mask flex">
        <div className="flex shrink-0 animate-scroll-x gap-14 pr-14 items-center">
          {[...phrases, ...phrases, ...phrases].map((p, i) => (
            <div key={i} className="flex items-center gap-14">
              <span className="font-display text-4xl lg:text-6xl font-extrabold tracking-[-0.02em] text-white/10 whitespace-nowrap">
                {p}
              </span>
              <span className="w-3 h-3 rounded-full bg-gradient-cm shrink-0"></span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandMarquee;
